function ErrorMessage({ error, id }: { error: string; id?: string }) {
  if (error) {
    return (
      <p id={id} role="alert" className="text-red-700">
        {error}
      </p>
    );
  }
  return <p />;
}

export default ErrorMessage;
